import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { shade } from 'polished';
import { Button as AntdButton } from 'antd';
// Define custom variants for styling
const colorStyles = {
    default: css `
    background-color: ${({ theme }) => shade(0.1, theme.colors.white)} !important;
    background: ${({ theme }) => shade(0.1, theme.colors.white)} !important;
    color: ${({ theme }) => theme.colors.dark} !important;
    box-shadow: 0px 2px 0px 1px ${({ theme }) => shade(0.2, theme.colors.white)};
    &:hover {
      background-color: ${() => shade(0.1, '#fff')}!important;
      background: ${() => shade(0.1, '#fff')}!important;
    }
  `,
    primary: css `
    box-shadow: 0px 2px 0px 1px ${({ theme }) => shade(0.2, theme.colors.primary)};
    background-color: ${({ theme }) => theme.colors.primary};
    background: ${({ theme }) => theme.colors.primary};
    color: #fff;
    &:hover {
      background-color: ${({ theme }) => shade(0.2, theme.colors.primary)}!important;
      background: ${({ theme }) => shade(0.2, theme.colors.primary)}!important;
    }
  `,
    danger: css `
    background-color: #ff5067 !important;
    background: #ff5067 !important;
    color: #fff;
    box-shadow: 0px 2px 0px 1px ${() => shade(0.2, '#ff5067')};
    &:hover {
      background-color: ${() => shade(0.2, '#ff5067')}!important;
      background: ${() => shade(0.2, '#ff5067')}!important;
    }
  `,
    gray: css `
    background-color: #6e6e6e;
    background: #6e6e6e;
    color: #fff;
    box-shadow: 0px 2px 0px 1px ${() => shade(0.2, '#6e6e6e')};
    &:hover {
      background-color: ${() => shade(0.2, '#6e6e6e')}!important;
      background: ${() => shade(0.2, '#6e6e6e')}!important;
    }
  `,
    warning: css `
    background-color: #ffa92e;
    color: #fff;
    box-shadow: 0px 2px 0px 1px ${() => shade(0.2, '#ffa92e')};
    &:hover {
      background-color: ${() => shade(0.2, '#ffa92e')}!important;
      background: ${() => shade(0.2, '#ffa92e')}!important;
    }
  `,
};
const StyledButton = styled(AntdButton) `
  border: none;
  border-radius: 15px;
  padding: 2px;
  font-size: 14px;
  line-height: calc(14px + 4px);
  max-width: 100%;
  padding: calc(calc(calc(5 * 1px) * 2) - 2px) calc(calc(calc(5 * 1px) * 3) - 2px);
  min-height: calc(calc(14px + 4px) + calc(calc(calc(5 * 1px) * 2) - 2px) * 2);
  border-radius: calc(15px - 2px);

  ${({ color }) => color && colorStyles[color]};

  /* &.bc-btn-color-primary.bc-btn-variant-solid {
    background-color: hsla(129, 60%, calc(50% - 6%), calc(1 - 0.2));
    background: hsla(129, 60%, calc(50% - 6%), calc(1 - 0.2));
    color: hsla(
      var(--ue-primary-color-font-color_h, 0),
      var(--ue-primary-color-font-color_s, 0%),
      var(--ue-primary-color-font-color_l, 100%),
      var(--ue-primary-color-font-color_t, 1)
    );
    --bc-control-height: 38px;

    .bc-btn-inner-wrapper {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      box-sizing: border-box;
      white-space: nowrap;
      font-size: 14px;
      line-height: calc(14px + 4px);
      gap: calc(5 * 1px);

      box-shadow: 0 1px 3px 0 #00000012;
      background-color: hsla(
        129,
        60%,
        50%,
        1
      );
    }
    &.gray-btn {
      background-color: hsl(
        var(--ue-tooltip-bg-color_h, 0),
        var(--ue-tooltip-bg-color_s, 0%),
        calc(var(--ue-tooltip-bg-color_l, 20%) + 20%),
        var(--ue-tooltip-bg-color_t, 0.9)
      );
      color: hsla(
        var(--ue-secondary-font-color_h, 0),
        calc(var(--ue-secondary-font-color_s, 0%) - 5%),
        var(--ue-secondary-font-color_l, 100%),
        var(--ue-secondary-font-color_t, 1)
      );
      .bc-btn-inner-wrapper {
        background-color: hsl(
          var(--ue-tooltip-bg-color_h, 0),
          var(--ue-tooltip-bg-color_s, 0%),
          calc(var(--ue-tooltip-bg-color_l, 20%) + 20%),
          var(--ue-tooltip-bg-color_t, 0.9)
        );
      }
    }

    &.bc-btn-sm {
      border-radius: var(--ue-border-radius-base, 8px);

      .bc-btn-inner-wrapper {
        font-size: var(--ue-font-size, 13px);
        line-height: calc(var(--ue-font-size, 13px) + 4px);
        padding: 5px 13px;
        border-radius: calc(var(--ue-border-radius-base, 8px) - 2px);

        min-height: calc(
          calc(14px + 4px) +
            calc(calc(5 * 1px) - 2px) * 2
        );
      }
    }
  } */
`;
export const Loader = styled.span `
  width: 16px;
  height: 16px;
  border: 2px solid #fff;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;

  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
// Define the Button component
const Button = ({ children, color, ...rest }) => {
    return (_jsx(StyledButton, { color: color, ...rest, children: children }));
};
export default Button;
